export default (
  state = {
    activeClusters: [],
    k12Schools: [],
    clusters: {},
    organization: {},
    orgImage: null,
    orgSettings: {},
    userDetails: {},
    mentorProfile: {},
    avatar: null,
    careersByCluster: [],
    selectedCareer: null,
    verificationError: false,
    avatarImageChanged: false,
    email: null,
    claimCode: null,
    district: null,
    orgUser: false,
    payload: {},
    k12SchoolsLoaded: false,
  },
  action,
) => {
  switch (action.type) {
    case 'ORG_MENTOR_SETUP.SET_ORG_DETAILS':
      return {
        ...state,
        organization: { ...state.organization, ...action.organization },
      };
    case 'ORG_MENTOR.SET_DISTRICT':
      return {
        ...state,
        district: action.district,
      };
    case 'ORG_MENTOR_SETUP.SET_ACTIVE_CLUSTERS':
      return {
        ...state,
        activeClusters: action.clusters,
      };
    case 'ORG_MENTOR_SETUP.POPULATE_CONTEXT':
      return {
        ...state,
        clusters: action.context,
        k12Schools: action.context.k12Schools || [],
      };
    case 'ORG_MENTOR_SETUP.SET_ORG_IMAGE':
      return {
        ...state,
        orgImage: action.orgImage,
      };
    case 'ORG_MENTOR_SETUP.SET_AVATAR_IMAGE':
      return {
        ...state,
        avatar: action.avatar,
      };
    case 'ORG_MENTOR_SETUP.SET_NEW_AVATAR':
      return {
        ...state,
        avatarImageChanged: true,
        mentorProfile: {
          ...state.mentorProfile,
          avatarImage: action.avatar,
        },
      };
    case 'ORG_MENTOR.POPULATE_CAREERS_BY_CLUSTER':
      return {
        ...state,
        careersByCluster: action.careers,
      };
    case 'ORG_MENTOR.SET_SELECTED_CAREER':
      return {
        ...state,
        selectedCareer: action.selectedCareer,
      };
    case 'ORG_MENTOR.SET_VERIFICATION_ERROR':
      return {
        ...state,
        verificationError: Array.isArray(action.error)
          ? action.error
          : [action.error],
      };
    case 'ORG_MENTOR.SET_EMAIL':
      return {
        ...state,
        email: action.email,
      };
    case 'ORG_MENTOR.SET_ORG_SETTINGS': {
      return {
        ...state,
        orgSettings: action.settings,
      };
    }
    case 'ORG_MENTOR.SET_MENTOR_PROFILE':
      return {
        ...state,
        mentorProfile: action.profile,
        avatarImageChanged: false,
      };
    case 'ORG_MENTOR.SET_CLAIM_CODE':
      return {
        ...state,
        claimCode: action.code,
      };
    case 'ORG_MENTOR_SETUP.SET_USER_DETAILS':
      return {
        ...state,
        userDetails: action.userDetails,
      };
    case 'ORG_MENTOR_SETUP.UPDATE_PAYLOAD':
      return {
        ...state,
        payload: {
          ...state.payload,
          ...action.payload,
        },
      };
    case 'ORG_MENTOR_SETUP.UPDATE_K12_SCHOOLS':
      return {
        ...state,
        k12Schools: action.k12Schools,
        k12SchoolsLoaded: true,
      };
    default:
      return state;
  }
};
